import type {ReactElement} from 'react';
import React from 'react';
import {ItemMovementOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-movement-options';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {ItemLockInPlaceOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-lock-in-place-option';
import {ItemFlipAndStretchOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-flip-and-stretch-options';
import {ItemAlignmentOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-alignment-options';
import {ItemLockInformationBox} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-lock-information-box';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

export function ItemPositionContextualOptions(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  return (
    <>
      {activeItem?.isTranscript() ? null : <ItemLockInformationBox />}
      {activeItem?.isTranscript() ? null : <ItemMovementOptions />}
      <ItemLockInPlaceOption />
      {activeItem && (activeItem.isTab() || activeItem.isText() || activeItem.isTableItem() || activeItem.isMenu() || activeItem.isTranscript()) ? null : (
        <ItemFlipAndStretchOptions />
      )}
      <ContextualMenuHeadingOption id="position-alignment-on-design-heading-option" text={window.i18next.t('pmwjs_alignment_on_design')} />
      <ItemAlignmentOptions />
    </>
  );
}
